import { createContext } from 'react';

import { IBillingInfoInvoicesContext } from '@shippypro/foundation/settings/types';

/**
 * This context will provide all the necessary data for the `Billing info and ivoices` tabs
 *
 * @author Fabio Mezzina <fabio.mezzina@shippypro.com>
 */
const BillingInfoInvoicesContext =
  createContext<IBillingInfoInvoicesContext | null>(null);

export default BillingInfoInvoicesContext;
